/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_PhysicsInputs */

const en_onboarding_genre_physics = /** @type {(inputs: Onboarding_Genre_PhysicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physics`)
};

const es_onboarding_genre_physics = /** @type {(inputs: Onboarding_Genre_PhysicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Física`)
};

/**
* | output |
* | --- |
* | "Physics" |
*
* @param {Onboarding_Genre_PhysicsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_physics = /** @type {((inputs?: Onboarding_Genre_PhysicsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_PhysicsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_physics(inputs)
	return en_onboarding_genre_physics(inputs)
});